// extracted by mini-css-extract-plugin
export default {"boxedTitle":"boxed-title_boxedTitle__cW7Qp"};